<template>
  <div class="container">
    <banner />
    <div class="newsListCon">
      <el-tabs class="mytabs wow animate__animated durationTime animate__fadeInUp" v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane
          v-for="item in tablist"
          :key="item.name"
          :label="item.label"
          :name="item.name"
        ></el-tab-pane>
      </el-tabs>
      <div class="newsList">
        <div
          v-for="item in dataList"
          :key="item.id"
          class="item"
          @click="handleDetail(item.id)"
        >
          <div class="textCon">
            <div class="time">
              {{ item.time }}
            </div>
            <div class="title">
              {{ item.title }}
            </div>
            <div class="brief">
              {{ item.brief }}
            </div>
          </div>
          <div class="imgbox">
            <img
              v-if="item.imageSrc"
              :src="require(`@/assets/${item.imageSrc}`)"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="paging">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size.sync="pageSize"
        :current-page.sync="currentPage"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import banner from "./components/banner";
import newsData from "./newsData";
export default {
  name: "news",
  components: {
    banner
  },
  data() {
    return {
      activeName: "全部",
      tabIndex: null, //记录当前tab选中的索引，对应type类型，处理从新闻详情返回时，重置与非重置当前页状态
      tablist: [
        {
          name: "全部",
          label: "全部"
        },
        {
          name: "展会风采",
          label: "展会风采"
        },
        {
          name: "项目拓展",
          label: "项目拓展"
        },
        {
          name: "Lemon动态",
          label: "Lemon动态"
        },
        {
          name: "其他",
          label: "其他"
        }
      ],
      dataList: [],
      currentPage: 1,
      pageSize: 5,
      total: 0
    };
  },
  watch: {
    activeName() {
      this.currentPage = 1;
    },
    updateData() {
      this.handleData();
    },
    $route(to) {
      const { query = {} } = to || {},
        { type = "" } = query;
      this.handleTabInit(type);
    }
  },
  computed: {
    updateData() {
      return {
        currentPage: this.currentPage,
        activeName: this.activeName
      };
    }
  },
  created() {
    this.handleData();
    this.handleTabInit(this.$route.query.type);
  },
  mounted() {},
  destroyed() {},
  methods: {
    handleDetail(id) {
      this.$router.push({
        name: "newsDetail",
        query: {
          id: id
        }
      });
    },
    handleTabInit(type) {
      const typeMap = {
        1: "展会风采",
        2: "项目拓展",
        3: "Lemon动态",
        4: "其他"
      };
      if (typeMap[type]) {
        this.activeName = typeMap[type];
      }
    },
    handleTabClick(tab) {
      if (this.tabIndex != tab.index) {
        if (tab.index == 0) {
          this.$router.replace("/news" );
        } else {
          this.$router.replace("/news?type=" + tab.index);
        }
      }
      this.tabIndex = tab.index
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    handleData() {
      let datas = [...newsData];
      if (this.activeName != "全部") {
        datas = newsData.filter(v => this.activeName == v.type);
      }

      const datasCopy = [...datas];

      this.dataList = datasCopy.splice(
        (this.currentPage - 1) * this.pageSize,
        this.pageSize
      );

      this.total = datas.length;
    }
  }
};
</script>

<style scoped lang="scss">
.newsListCon {
  padding: 0.8rem 2.18rem 0.6rem;
  .newsList {
    .item {
      padding: 0.4rem 0 0.58rem;
      border-bottom: 1px solid rgb(153, 153, 153, 0.5);
      display: flex;
      align-items: center;
      cursor: pointer;
      &:last-child {
        border-bottom: 0;
      }
      .textCon {
        flex: 1;
        font-size: 0.14rem;
        color: #333333;
        font-weight: 500;
        padding-right: 0.65rem;
        .time {
          display: inline-block;
          min-width: 1.49rem;
          height: 0.3rem;
          line-height: 0.3rem;
          text-align: center;
          background: url(../../assets/image/news/timebg.png) center no-repeat;
          background-size: 100% 100%;
          margin-bottom: 0.2rem;
        }
        .title {
          font-size: 0.24rem;
          font-weight: 600;
          margin-bottom: 0.2rem;
        }
        .brief {
          line-height: 0.3rem;
          width: 100%;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2; /* 设置最大显示行数 */
          -webkit-box-orient: vertical;
        }
      }
      .imgbox {
        width: 3.54rem;
        height: 1.7rem;
        overflow: hidden;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.mytabs {
  .el-tabs__header {
    margin: 0 0 0.4rem;
  }
  .el-tabs__nav-wrap::after {
    display: none;
  }
  .el-tabs__active-bar {
    opacity: 0;
  }
  .el-tabs__item {
    color: #333 !important;
    font-size: 0.16rem;
    height: 0.4rem;
    line-height: 0.4rem;
    padding: 0 0.06rem !important;
    margin-right: 0.3rem !important;
    &.is-active {
      border-bottom: 1px solid #fef100;
    }
  }
}
.paging {
  .el-pagination {
    padding: 0;
    color: #333 !important;
    display: flex;
    justify-content: center;
    background: #fef100;
  }
  .el-pagination button {
    margin: 0 !important;
    height: 0.8rem !important;
    line-height: 0.8rem !important;
    min-width: 0.8rem !important;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #fdfce3 !important;
    color: #333;
  }
  .el-pager li {
    margin: 0 !important;
    padding: 0 !important;
    background: transparent !important;
    font-size: 0.16rem;
    height: 0.8rem !important;
    line-height: 0.8rem !important;
    width: 0.72rem;
  }
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    background-color: transparent;
    color: #333 !important;
    transition: all 0.3s ease-in-out;
    &:hover {
      background-color: rgba(253, 252, 227, 0.8) !important;
    }
  }
  .el-pagination .btn-next .el-icon,
  .el-pagination .btn-prev .el-icon {
    font-size: 0.14rem;
    color: #333;
    font-weight: 400;
  }
  .el-icon-arrow-left:before {
    content: "上一页";
  }
  .el-icon-arrow-right:before {
    content: "下一页";
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/news/index.vue